import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import ModalContainer from '@components/modals/ModalContainer';
import ModalHeader from '@components/modals/ModalHeader';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { getMaterialHistory } from '@services/materialService';

import { FABRIC_TYPE_LIST, goToMaterialView, isFabric } from '@utils/MaterialsUtil';
import { onGetLocalFromUtc } from '@utils/Util';

const HistoryModal = ({ onCloseModal }) => {
	const [historyList, setHistoryList] = useState([]);
	const dispatch = useDispatch();
	const { id } = useParams();

	const getHistory = async () => {
		dispatch(openLoader());
		const response = await getMaterialHistory(id);
		setHistoryList(response);
		dispatch(closeLoader());
	};

	const getConsumptionUnit = (materialResponse) => {
		let value = materialResponse?.fabricDetailsTableResponse?.fabricType;
		if (materialResponse?.quantityUnit) return 'PCS';
		else if (value) return FABRIC_TYPE_LIST.find((item) => item.name === value)?.unit;
	};

	const getMaterialTitle = (materialType) => {
		if (isFabric(materialType)) {
			return 'Fabric';
		} else if (materialType === 'TRIMS') {
			return 'Trims';
		} else {
			return 'Accessories';
		}
	};

	const getMaterialTypeName = (materialType) => {
		if (isFabric(materialType)) {
			return 'FABRIC';
		} else if (materialType === 'BRANDING') {
			return 'ACCESSORIES';
		} else {
			return 'TRIMS';
		}
	};

	const getActionType = (actionType) => {
		if (actionType === 'PRODUCT_MATERIAL_ADDED') {
			return 'Added';
		} else {
			return 'Removed';
		}
	};

	const renderHistoryList = () => {
		return historyList?.map((item) => {
			return (
				<div className="single-history mb-3 pb-3 border-bottom-solid" key={item?.id}>
					<div className="history-header mb-2">
						<p className="semibold-14">
							{getMaterialTitle(item?.materialResponse?.materialType)}{' '}
							{getActionType(item?.actionType)} by {item?.userResponse?.name}{' '}
							<span className="regular-12 gray_dark_03 weight-400">|</span>{' '}
							<span className="text-uppercase">
								{onGetLocalFromUtc(item?.localDateTime, 'DD MMM, YY[,] hh:mm A')}
							</span>
						</p>
					</div>
					<div className="history-content">
						<button
							className="button text-only weight-500 mb-1 hover-underline"
							onClick={() =>
								goToMaterialView(
									item?.materialResponse?.libraryId,
									getMaterialTypeName(item?.materialResponse?.materialType)
								)
							}
							disabled={item?.isMaterialDeleted}
						>
							<span className="regular-12">{item?.materialResponse?.referenceNumber}</span>
						</button>

						<p className="regular-12 gray_dark_01 mb-1">
							{isFabric(item?.materialResponse?.materialType) ? (
								<>
									<span>
										{item?.materialResponse?.fabricDetailsTableResponse?.fabricType}
									</span>
									{item?.materialResponse?.fabricDetailsTableResponse?.construction && (
										<span>
											,&nbsp;
											{item?.materialResponse?.fabricDetailsTableResponse?.construction}
										</span>
									)}
								</>
							) : (
								<>
									<span>
										{
											item?.materialResponse?.trimsAndBrandingTableResponse
												?.subCategoryType?.category
										}
									</span>
									{item?.materialResponse?.trimsAndBrandingTableResponse?.subCategoryType
										?.name && (
										<span>
											,&nbsp;
											{
												item?.materialResponse?.trimsAndBrandingTableResponse
													?.subCategoryType?.name
											}
										</span>
									)}
								</>
							)}
						</p>
						{isFabric(item?.materialResponse?.materialType) ? (
							<p className="regular-12 gray_dark_01 mb-1">
								<span>
									{item?.materialResponse?.fabricDetailsTableResponse?.compositionPartList
										?.map(
											(composition) =>
												`${composition.percentage}% ${composition.fiberName}`
										)
										.join(' ')}
								</span>
								<span>, {item?.materialResponse?.fabricDetailsTableResponse?.gsm} GSM</span>
							</p>
						) : (
							<p className="regular-12 gray_dark_01 mb-1">{item?.materialResponse?.name} </p>
						)}

						<p className="regular-12 gray_dark_01 mb-1">
							<span className="gray_dark_02">Booked:</span>{' '}
							{item?.materialResponse?.bookedQuantity}
							{getConsumptionUnit(item?.materialResponse)} |{' '}
							<span className="gray_dark_02 mr-1">Issued:</span>
							{item?.materialResponse?.issuedQuantity}
							{getConsumptionUnit(item?.materialResponse)}
						</p>
					</div>
				</div>
			);
		});
	};

	useEffect(() => {
		getHistory();
	}, []);

	return (
		<ModalContainer className="modal-right " onCloseModal={() => {}}>
			<div className="common-popup">
				<ModalHeader
					title="History"
					subTitle={
						'Material added or removed after February 11, 2025, will appear in the history.'
					}
					onClose={onCloseModal}
					extraClass="sticky-0 bg-white"
				/>
				<div className="common-popup-body">
					<div className="all-history">
						{historyList?.length > 0 ? (
							renderHistoryList()
						) : (
							<div className="alert alert-secondary">
								<span className="regular-14">No history found</span>
							</div>
						)}
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default HistoryModal;
